import { useContext, useEffect, useState } from "react";
import { getFiles, createFile, updateFile, downloadFile } from "../services/configurations/pointsOfAttention/uploadanddownload";
import { AppContext } from "../context";
import { filesFormatter } from "../utils";

type DataResponseType = "DATA" | "ID";
type ActionType = "CREATE" | "UPDATE" | "DOWNLOAD";

const handleActionFunction = (action: ActionType, t: Function) => {
  switch (action) {
    case "CREATE":
      return {
        actionFn: createFile,
        fnMsg: t("PointsOfAttention.uploadFileApiCreateLabel"),
      };
      case "UPDATE":
        return {
          actionFn: updateFile,
          fnMsg: t("PointsOfAttention.uploadFileApiUpdateLabel"),
        };
    case "DOWNLOAD":
      return {
        actionFn: downloadFile,
        fnMsg: t("PointsOfAttention.fileApiDownloadLabel"),
      };
    default:
      return {
        actionFn: () => {},
        fnMsg: "",
      };
  }
};

export const useUploadAndDownload = (type: DataResponseType) => {
  const {
    t,
    toast,
    appState: { selectedApp },
    setAppState,
  } = useContext(AppContext);
  const [dataFiles, setDataFiles] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);

  const reloadFnUploadAndDownload = () => {
    setDataFiles(null);
    setReload((prev) => prev + 1);
  };

  const uploadAndDownloadAction = async (action: ActionType, data: any) => {
    const { actionFn, fnMsg } = handleActionFunction(action, t);
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const actionStatus = await Promise.resolve(actionFn(data, selectedApp?.tenantid!, selectedApp?.appid!))
      .then((response) => {
        toast.current.replace({
          severity: "success",
          summary: "",
          detail: `${fnMsg}`,
          life: 3000,
        });
        return "SUCCESS";
      })
      .catch((error) => {
        toast.current.replace({
          severity: "error",
          summary: "",
          detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        });
        return "ERROR";
      });
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
    }));
    return actionStatus;
  };

  useEffect(() => {
    if (type === "DATA") {
      (async function () {
        await Promise.resolve(getFiles(selectedApp?.appid!, selectedApp?.tenantid!))
          .then((response) => {
            const serviceResponse = filesFormatter(response?.data, t);
            setDataFiles(serviceResponse);
          })
          .catch((error) => {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          });
      })();
    }
  }, [toast, reload, type, setAppState]);

  return {
    dataFiles,
    uploadAndDownloadAction,
    reloadFnUploadAndDownload,
  };
};